declare global {
  interface Window {
    dataLayer: any[];
  }
}

export function trackClick(name: string) {
  analyticsTrack({ event: "clickButton", name });
}

export function analyticsTrack(event: any) {
  pushToDL("tjwc_", event);
}

export function analyticsTrackNoPrefix(event: any) {
  pushToDL("", event);
}

function pushToDL(prefix: string, event: any) {
  window.dataLayer = window.dataLayer || [];
  event.event = `${prefix}${event.event}`;
  window.dataLayer.push(event);
}
